import { Route } from "@angular/router";
import { FinalizarCompraPage } from "./finalizar-compra.page";

export const FinalizarCompraRouter: Route[] = [
  { path: 'finalizar-compra', component: FinalizarCompraPage }
];
